<section class="trials" id="trials">
  <div class="trials__title">
    <h1>Most important medical trials</h1>
  </div>

  <div class="trials__list">
    <div *ngFor="let trial of trials" class="trials__list__item">
      <div class="trials__list__item__title">
        <h1>
         {{trial.trialName}}
        </h1>
      </div>
      <div class="trials__list__item__content">
        <div data-aos="zoom-out-up" data-aos-duration="1000" class="text">
            <p>{{trial.trialText}}</p>
          </div>

          <div data-aos="zoom-out-down" class="image">
              <img [src]="trial.trialGraphUrl ||'../../../assets/Drug Intercation.svg'" alt="">
          </div>
          <div class="download" >
            <app-button [href]="trial?.imageUrl" [text]="'View Full paper'" classList="btn bordered rounded"></app-button>
          </div>
      </div>
    </div>
    <!-- <div class="trials__list__item">
      <div class="trials__list__item__title">
        <h1>
          Trial 1
        </h1>
      </div>
      <div class="trials__list__item__content">
        <div data-aos="zoom-out-up" data-aos-duration="1000" class="text">
            <p>This is will be a paragraph with a small description of what happens in the video. When the active ingredient
              is inserted into a human’s system to it doing its work.This is will a paragraph with a small description of what
              happens in the video. When the active ingredient is inserted into a human’s system to it doing its work.This is
              will a paragraph with a small description of what happens in the video. When the active ingredient is inserted
              into a human’s system to it When the active ingredient is inserted into a human’s system to it doing its
              work.This is will a paragraph with a small description of what happens in the video. When the active ingredient
              is inserted into a human’s system to it doing its work.This is will a paragraph with a small description of what
              happens in the video. When the active ingredient is inserted into a human’s system to it</p>
          </div>

          <div data-aos="zoom-out-down" class="image">
              <img src="../../../assets/Drug Intercation.svg" alt="">
          </div>
      </div>
    </div> -->
  </div>
  <span class="down-ref">(04)</span>
</section>
